import React, { FC, useEffect } from 'react';
import { useDispatchEx, useSelectorEx } from "../../hooks/redux";
import Preloader from "../molecules/Preloader/Preloader";
import { useParams, useSearchParams, useNavigate, useLocation } from "react-router-dom";
import OrdersList from "../molecules/OrdersList/OrdersList";
import { asyncGetOrdersAction } from "../../redux/slices/orders/ordersAction";
import { setCurrentPageOrders, setSelectedCount, setSelectedOrders } from "../../redux/slices/orders/ordersSlice";

interface OrdersContainerProps {
    onDelete: (id: number) => void;
}

const OrdersContainer: FC<OrdersContainerProps> = ({ onDelete }) => {
    const { isLoading, orders, totalOrders, currentPage } = useSelectorEx(state => state.orders);

    const { pageNumber, currencyCode, statusCode } = useParams();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatchEx();

    const navigate = useNavigate();
    const location = useLocation();

    const msgStatus = searchParams.get('msgStatus') || 'ALL';

    useEffect(() => {
        const newPageNumber = pageNumber ? Number(pageNumber) : 1;
        const currentCurrency = currencyCode || 'ALL';
        const currentStatus = statusCode || 'ALL';

        dispatch(setCurrentPageOrders(newPageNumber));

        dispatch(asyncGetOrdersAction({
            page: newPageNumber,
            currency: currentCurrency,
            status: currentStatus,
            msgStatus: msgStatus
        }));
    }, [pageNumber, currencyCode, statusCode, msgStatus, dispatch]);

    const getBaseUrl = () => {
        const currentCurrency = currencyCode || 'ALL';
        const currentStatus = statusCode || 'ALL';
        let url = `/admin/orders`;

        if (currentCurrency !== 'ALL' && currentStatus !== 'ALL') {
            return `${url}/currency/${currentCurrency}/status/${currentStatus}`;
        }
        if (currentCurrency !== 'ALL') {
            return `${url}/currency/${currentCurrency}`;
        }
        if (currentStatus !== 'ALL') {
            return `${url}/status/${currentStatus}`;
        }
        return url;
    };

    const onPagination = (page: number) => {
        navigate(`${getBaseUrl()}/page/${page}${location.search}`);
    }

    const onCheckSelect = (email: string) => {
        const oldItems: string = localStorage.getItem('selectedEmail') ?? '';
        let oldArraySelected: string[] = oldItems ? oldItems?.split(',') : [];

        if (oldArraySelected?.includes(email)) {
            oldArraySelected = oldArraySelected.filter(item => item !== email);
        } else {
            oldArraySelected.push(email);
        }

        dispatch(setSelectedCount(oldArraySelected.length));
        dispatch(setSelectedOrders(oldArraySelected));
    }

    if (isLoading) return <Preloader />;

    return (
        <OrdersList
            isDelete={true}
            onDelete={onDelete}
            onCheckSelect={onCheckSelect}
            items={orders}
            totalCount={totalOrders}
            onChangePagination={onPagination}
            currentPage={currentPage}
            pageUrl={getBaseUrl()}
        />
    );
};

export default OrdersContainer;